<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_chat')
}

const isOnChatSection = computed(() => {
  return route.path.startsWith('/communication')
})

const goToChat = () => {
  router.push('/communication')
}
</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        We need to be able to communicate with other civilizations!
      </p>
      <p class="pb-2">
        Lets head over to the communication section.
      </p>
    </template>

    <template #alerts>
      <Alert type="info" class="hidden md:flex">
        Click on the "Communication" button in the top menu.
      </Alert>
      <Alert type="info" class="md:hidden">
        Tap on the "menu" and then the "Communication" item
      </Alert>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnChatSection" @click="goToChat" class="mr-2">
        Go to Chat
      </ActionButton>
      <ActionButton @click="handleNextStep">
        I'm there!
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>